import { render, staticRenderFns } from "./lightcontrol.vue?vue&type=template&id=11c77a94"
import script from "./lightcontrol.vue?vue&type=script&lang=js"
export * from "./lightcontrol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports